var UserEndpoints;
(function (UserEndpoints) {
    UserEndpoints["CreatePassword"] = "users/create-password";
    UserEndpoints["CreatePasswordFromToken"] = "users/create-password-from-token";
    UserEndpoints["ForgotPassword"] = "/users/forgot-password";
    UserEndpoints["GetPartnerUserState"] = "/users/partners/get-partner-user-state";
    UserEndpoints["GetUser"] = "/users/get-user";
    UserEndpoints["GetAuthCode"] = "/users/get-auth-code";
    UserEndpoints["Logout"] = "/users/log-out";
    UserEndpoints["PreVerifyCreatePassword"] = "/users/pre-verify-create-password";
    UserEndpoints["ResetPassword"] = "/users/reset-password";
    UserEndpoints["PreVerifyBirthdate"] = "/users/pre-verify-birthdate";
    UserEndpoints["PreVerifyMfaCode"] = "/users/pre-verify-mfa-code";
    UserEndpoints["SendEmailVerification"] = "/users/send-email-verification";
    UserEndpoints["SendMfaCode"] = "/users/send-mfa-code";
})(UserEndpoints || (UserEndpoints = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["Unspecified"] = "USER_STATUS_UNSPECIFIED";
    UserStatus["NotFound"] = "NOT_FOUND";
    UserStatus["Active"] = "ACTIVE";
    UserStatus["Inactive"] = "INACTIVE";
})(UserStatus || (UserStatus = {}));
var UserAccountType;
(function (UserAccountType) {
    UserAccountType["Unspecified"] = "USER_ACCOUNT_TYPE_UNSPECIFIED";
    UserAccountType["Consumer"] = "CONSUMER";
    UserAccountType["Admin"] = "ADMIN";
    UserAccountType["CustomerSupport"] = "CUSTOMER_SUPPORT";
    /** For customers applying through a partner app (sunrise) */
    UserAccountType["Partner"] = "PARTNER";
})(UserAccountType || (UserAccountType = {}));
/**
 * What a note on a user's timeline records. `ManualNote` is the only value an
 * operator ever writes — everything else is an audit event emitted by a service
 * when it changes something, so the timeline doubles as a change log.
 *
 * The values split into three shapes, which is what a renderer needs to know:
 * `ManualNote` carries free `text`; the `*Change` values carry `oldValue`/
 * `newValue` and often no `text` at all; the remaining event values carry
 * `text` plus a populated `metadata` map.
 */
var NoteType;
(function (NoteType) {
    NoteType["Unspecified"] = "NOTE_TYPE_UNSPECIFIED";
    NoteType["ManualNote"] = "MANUAL_NOTE";
    NoteType["DobChange"] = "DOB_CHANGE";
    NoteType["NameChange"] = "NAME_CHANGE";
    NoteType["SsnChange"] = "SSN_CHANGE";
    NoteType["PhoneChange"] = "PHONE_CHANGE";
    NoteType["EmailChange"] = "EMAIL_CHANGE";
    NoteType["AddressChange"] = "ADDRESS_CHANGE";
    NoteType["BillingCycleDayChange"] = "BILLING_CYCLE_DAY_CHANGE";
    NoteType["BiltProductChangeRequest"] = "BILT_PRODUCT_CHANGE_REQUEST";
    NoteType["CardReplacement"] = "CARD_REPLACEMENT";
    NoteType["CardActivation"] = "CARD_ACTIVATION";
    NoteType["AccountStatusChange"] = "ACCOUNT_STATUS_CHANGE";
    NoteType["CreditLimitChange"] = "CREDIT_LIMIT_CHANGE";
    NoteType["CreditBalanceRefund"] = "CREDIT_BALANCE_REFUND";
    NoteType["AuthorizedUserClosed"] = "AUTHORIZED_USER_CLOSED";
    NoteType["PlaidPermissionRevoked"] = "PLAID_PERMISSION_REVOKED";
    NoteType["WalletProvisioning"] = "WALLET_PROVISIONING";
    NoteType["FeeWaived"] = "FEE_WAIVED";
    NoteType["PartnerAccountDeleted"] = "PARTNER_ACCOUNT_DELETED";
    NoteType["IncomeChange"] = "INCOME_CHANGE";
})(NoteType || (NoteType = {}));
/**
 * @todo This enum is a WIP for project Sunrise and subject to change
 */
var PartnerUserState;
(function (PartnerUserState) {
    PartnerUserState["Unspecified"] = "PARTNER_CUSTOMER_STATE_UNSPECIFIED";
    /**
     * Partner user has not yet applied for card.
     * Cardless user does not exist for partner user.
     */
    PartnerUserState["NewUser"] = "NEW_USER";
    /**
     * Partner user applied for and was approved for Cardless card.
     * Cardless user exists for partner user.
     */
    PartnerUserState["Active"] = "ACTIVE";
    /**
     * Partner user applied for and was declined for Cardless card.
     * Cardless user does not exist for partner user.
     */
    PartnerUserState["ApplicationDeclined"] = "APPLICATION_DECLINED";
})(PartnerUserState || (PartnerUserState = {}));
export { NoteType, PartnerUserState, UserAccountType, UserEndpoints, UserStatus, };
